import { FunctionGroupingArrayByKey } from "radium-omnibus";

const BaskerFormatDataToBackEnd = (cart) => {
  try {
    const data = FunctionGroupingArrayByKey(cart, "master_id");

    let water = data?.filter((item) => item?.key === undefined);
    let programs = data?.filter((item) => item?.key !== undefined);
    let formatedData = programs?.map((row) => {
      const masterIndex = row?.value?.findIndex(
        (item) => item?.master === true
      );

      const addons = row?.value?.filter((item) => !item?.master);

      return {
        ...row?.value?.[masterIndex],
        addons,
      };
    });

    let output = {
      programs: formatedData,
    };

    if (water?.length > 0) {
      output = {
        ...output,
        water: water[0].value[0],
      };
    }

    return output;
  } catch (error) {
    console.error("BaskerFormatDataToBackEnd", error);
  }
};

export default BaskerFormatDataToBackEnd;
